import { VBModal } from './modal';
import { pluginFactory } from '../../utils/plugins';
var VBModalPlugin =
/*#__PURE__*/
pluginFactory({
  directives: {
    VBModal: VBModal
  }
});
export { VBModalPlugin, VBModal };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/modal/index.js
// module id = g8cA
// module chunks = 0